<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-form label-width="100px">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="筛选学生">
                                <el-select v-model="$parentInfo.Dialogs_ReturnList.filter.student_id" placeholder="学生"
                                           clearable
                                           filterable remote
                                           :remote-method="handelSearchByStudentName"
                                           @change="handleInfo()">
                                    <el-option
                                            v-for="item in students"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="筛选合同ID">
                                <el-select v-model="$parentInfo.Dialogs_ReturnList.filter.invoice_id" placeholder="学生"
                                           clearable
                                           filterable remote
                                           :remote-method="handelSearchByInvoiceId"
                                           @change="handleInfo()">
                                    <el-option
                                            v-for="item in invoices"
                                            :key="item.id"
                                            :label="item.id"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-table
                        :data="orderLeaseInventory"
                        style="width: 100%"
                        size="middle"
                        :height="550"
                >
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table
                                    :data="props.row.invoiceShops"
                                    style="width: 100%"
                                    size="middle"
                            >
                                <el-table-column prop="shop_name" label="商品"></el-table-column>
                                <el-table-column prop="serial_id" label="序列号"></el-table-column>
                                <el-table-column prop="position" label="状态"></el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button size="mini" @click="handleReview(scope.row.invoiceItem_shop_id)" v-if="scope.row.position=='已分配'">撤回</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column prop="invoice_id" label="合同编号"></el-table-column>
                    <el-table-column prop="student_name" label="学生姓名"></el-table-column>
                    <el-table-column prop="return_status" label="状态"></el-table-column>
                    <el-table-column label="" width="65">
                        <template scope="scope">
                            <el-radio :label="scope.row.invoice_id" v-model="invoiceid" @change.native="handleSelectionChange(scope.$index,scope.row)">&nbsp</el-radio>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="$parentInfo.Dialogs_ReturnList.currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="$parentInfo.Dialogs_ReturnList.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: right">
            <el-button size="mini" @click="handleReturn()">归还</el-button>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialogs_ReturnList",
        data() {
            return {
                invoiceid:'',
                templateSelection:'',
                students:[],
                invoices:[]
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInfo();
            this.handelSearchByStudentName();
            this.handelSearchByInvoiceId();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderLeaseInventory: function () {
                return this._.orderBy(this.$parentInfo.Dialogs_ReturnList.leaseInvoices, 'invoice_id', 'asc');
            }
        },
        methods: {
            handleInfo(currentPage = 1){
                if (currentPage === 1) {
                    this.$parentInfo.Dialogs_ReturnList.currentPage = 1
                }
                this.$parentInfo.Dialogs_ReturnList.loading = true;
                this.$axios.get(store.state.server + '/getReturnList?'+
                    'studentId='+this.$parentInfo.Dialogs_ReturnList.filter.student_id +
                    '&invoiceId='+this.$parentInfo.Dialogs_ReturnList.filter.invoice_id +
                    '&page='+this.$parentInfo.Dialogs_ReturnList.currentPage +
                    '&currentPageSize=' + this.$parentInfo.Dialogs_ReturnList.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$parentInfo.Dialogs_ReturnList.leaseInvoices=response.data.content.list
                        this.$parentInfo.Dialogs_ReturnList.total=response.data.content.total
                        this.$parentInfo.Dialogs_ReturnList.loading = false;
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleInit(){

            },
            handleChange(){

            },
            handleSelectionChange(index,row) {
                this.templateSelection = row;
            },
            handleSizeChange(val) {
                this.$parentInfo.Dialogs_ReturnList.currentPageSize = val;
                this.handleInfo(this.$parentInfo.Dialogs_ReturnList.currentPage, this.$parentInfo.Dialogs_ReturnList.currentPageSize)
            },
            handleCurrentChange(val) {
                this.$parentInfo.Dialogs_ReturnList.currentPage = val;
                this.handleInfo(this.$parentInfo.Dialogs_ReturnList.currentPage, this.$parentInfo.Dialogs_ReturnList.currentPageSize)
            },
            handleReturn(){
                this.$Win.openModal('Dialogs_ReturnEquipment', 800, 400, '归还',{'invoiceId':this.templateSelection.invoice_id});
            },
            handelSearchByStudentName(val=''){
                this.$axios.get(store.state.server + '/searchByStudentName?studentName=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.students=response.data.content.students
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchByInvoiceId(val=''){
                this.$axios.get(store.state.server + '/searchByInvoiceId?invoiceId=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.invoices=response.data.content.invoiceIds
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleReview(invoiceItem_shop_id){
                this.$axios.post(store.state.server + '/cancelReturn',{
                    'invoiceItemShopId':invoiceItem_shop_id,
                }).then((response) => {
                    if (response.data.code == '0000') {
                        this.templateSelection=[];
                        this.$set(this.$parentInfo.leaseInventory,response.data.content.shop.id,response.data.content.shop)
                        this.$set(this.$parentInfo.Dialog_LeaseInvoice.leaseInvoices,response.data.content.invoice.invoice_id,response.data.content.invoice)
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            }
        }
    }
</script>

<style scoped>

</style>